import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { getUserIsAuthentificated, getUserAgreements, getUserEmailVerifyState } from 'Modules/user/data/selectors'
import { openListingTermsConditionModal } from 'Modules/modals/actions'
import { LISTING_SOURCE, LISTING_SOURCE_TERMS } from '../defaults/listing'
/**
 * some listing source requires terms of condition agreement
 */
const useRequiresTermsOfUseAgreement = ({ listingSource } = {}) => {
  const dispatch = useDispatch()
  const userIsAuthentificated = useSelector(getUserIsAuthentificated)
  const emailVerified = useSelector(getUserEmailVerifyState)
  const agreedTermsOfUses = useSelector(getUserAgreements)


  // This used to be fetched from api but due to it being constant the api call dropped
  // And hardcoded here
  const requiredTermConditions = useMemo(() => LISTING_SOURCE_TERMS.reduce((acc, source) => {
    if(source.requires_signatory) {
      acc[source.name] = source.id
    }
    return acc
  }, {}), [LISTING_SOURCE_TERMS])


  const termsConditionRequiredId = requiredTermConditions?.[listingSource]
  const alreadyAgreedTerm = agreedTermsOfUses?.[listingSource]
  const openListinerTermsModal = () =>
    dispatch(
      openListingTermsConditionModal({
        modalData: {
          listingSource: {
            id: termsConditionRequiredId,
            name: listingSource,
          },
        },
      }),
    )
  if(!listingSource) return {}

  return {
    /**
     * only used to show terms condition modal or listing page hero section
     */
    requireTermsConditionAgreement: !!(
      userIsAuthentificated &&
      // check if user is already agreed on terms
      !alreadyAgreedTerm &&
      // check if the listing requires terms of use agreement
      termsConditionRequiredId
    ),
    // required source id
    termsConditionRequiredId,
    requireTermsEmailVerification: alreadyAgreedTerm && !emailVerified,
    openTermsConditionModal: openListinerTermsModal,
  }
}

useRequiresTermsOfUseAgreement.PropTypes = {
  listingSource: PropTypes.oneOf(Object.keys(LISTING_SOURCE)),
}
export default useRequiresTermsOfUseAgreement
